import createCache from '@emotion/cache';

export { CacheProvider } from '@emotion/react';
export type { EmotionCache } from '@emotion/react';

export const createEmotionCache = () => createCache({ key: 'css' });
